import React from 'react';

import { useAppMonitor } from '../../../../monitor';
import { showNotOnMobileDialog } from '../../../../store/actions/popupActions';
import { canCurrentUserSeeParapetLoads } from '../../../../store/selectors/parapetLoadSelectors';
import {
  applicationOnInsertingManualLoad,
  applicationOnInsertingMovingLoadSettings,
  applicationOnInsertingParapetLoadSettings,
} from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector, useIsClientInMobileMode } from '../../../hooks';
import CascadingSceneMenuItem from '../common/CascadingSceneMenuItem';
import { SceneMenuItem } from '../common/SceneMenuItem';

interface Props {
  monitorText: string;
  onChooseItem: () => void;
  disabled?: boolean;
}
export function AdditionalLoadsFlyout({ monitorText, onChooseItem, disabled = false }: Props) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const mobile = useIsClientInMobileMode();
  const currentUserCanSeeParapetLoads = useAppSelector(canCurrentUserSeeParapetLoads);

  function handleClick(name: string, action: () => { type: string }) {
    if (mobile) {
      onChooseItem();
      dispatch(showNotOnMobileDialog('Creating items is not yet available on mobile.'));
      return;
    }

    dispatch(action());
    monitor.recordInteraction(`${monitorText} => Insert ${name} clicked`);
    onChooseItem();
  }

  return (
    <CascadingSceneMenuItem label="Additional Loads" disabled={disabled}>
      <SceneMenuItem
        text="Manual Load"
        disabled={disabled}
        onClick={() => handleClick('Manual Load', applicationOnInsertingManualLoad)}
      />
      <SceneMenuItem
        text="Moving Load"
        disabled={disabled}
        onClick={() => handleClick('Moving Load', applicationOnInsertingMovingLoadSettings)}
      />
      {currentUserCanSeeParapetLoads && (
        <SceneMenuItem
          text="PAL Load"
          disabled={disabled}
          onClick={() => handleClick('PAL Load', applicationOnInsertingParapetLoadSettings)}
        />
      )}
    </CascadingSceneMenuItem>
  );
}
